import c_13 from "../../assets/audio-screen/unit13/c_13.mp3"
import c_13_1 from "../../assets/audio-screen/unit13/c_13_1.mp3"


export const audio13 = [
   {
    'text':'Maruko: Chào chị, chị làm ơn cho em hỏi chút ạ?\nLan: Chào em, em muốn hỏi gì?\nMaruko: Dạ, chỉ có thể chỉ cho em đường đến hồ Hoàn Kiếm được không ạ?\nLan: Em nên đi thẳng đường Lê Duẩn sau đó rẽ tay trái là đường Hai Bà Trưng, tiếp đó em đi thẳng khoảng 500 m sẽ thấy hồ Hoàn Kiếm\nMaruko: Em cảm ơn chị ạ!\nLan: Thế em tên gì, em đến từ nước nào?\nMaruko: Em tên Maruko, em đến từ Nhật Bản.\nLan: Em đến Việt Nam làm việc hay là đi du lịch?\nMaruko: Em đi du lịch chỉ a!\nLan: Chị hiểu rồi, em đi cẩn thận và vui vẻ nhé!\nMaruko: Cảm ơn chị!\n',
    'audio': c_13,
  },

];

export const audio13_1 = [
    {
      'text':'Lee: Con yêu! Hôm nay con có khỏe không?\nSarah: Con khỏe mẹ ạ! Nhưng ngày mai con sẽ phải nộp rất nhiều bài tập ở trường.\nLee: Vậy mẹ khuyên con nên làm bài tập tiếng Anh từ tối nay\nSarah: Vâng ạ! Nhưng cô giáo còn đề nghị con làm bài tập toán trước ạ.\nLee: Vậy sao. Vậy con có muốn mẹ giúp gì không?\nSarah: Dạ, mẹ có thể gợi ý làm bài toán khó này cho con được không ạ.\nLee: Tại sao không? Vậy chúng ta bắt đầu làm vào lúc 9 giờ 30 phút tối nhé.\nSarah:  9 giờ 30 tôi còn bận làm bài tập vặn mẹ ạ. 10 giờ 10 phút tối nhé.\nLee: Mẹ đồng ý.\n ',
      'audio': c_13_1,
   },
 
 ];